import Order from '../apis/order';

const state = {
    onGoingOrders: [],
    pastOrder: [],
    orderDetail: [],
    place_order_data: [],
    isPickupDelivery: '1',
    chowmanPayOrderData:{},
    chowmanPayGiftVoucher:{}
};
const actions = {
    getOnGoingOrder({ commit }, data) {
        return Order.OnGoingOrders(data).then(response => {
            if (response.data.code == 200) {
                commit('getOnGoingOrder', response.data.Result)
            }
            return response.data;
        })
    },

    getPastOrder({ commit }, data) {
        return Order.PastOrders(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
                //commit('getPastOrder', response.data.Result)
            }
            return response.data;
        })
    },

    viewOrderDetail({ commit }, data) {
        return Order.viewOrderDetails(data).then(response => {
            if (response.data.code == 200) {
                commit('viewOrderDetail', response.data.Result)
            }
            return response.data;
        })
    },

    placeOrder({ commit }, data) {
        return Order.placeOrder(data).then(response => {
            if (response.data.code == 200) {
                // commit('placeOrder', response.data.Result)
            }
            return response.data;
        })
    },
    postPaymentMethod({ commit }, data) {
        return Order.postPaymentMethod(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },
    getOrderPaymentStatus({ commit }, data) {
        return Order.getOrderStatus(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    placeOrderData({ commit }, data) {
        commit('placeOrderData', data)
    },

    orderRatingData({ commit }, data) {
        return Order.addOrderRating(data).then(response => {
            if (response.data.code == 200) {
                //commit('orderRating', response.data.Result)
                return response.data;
            }
            return response.data;
        })
    },

    checkOrderRating({ commit }, data) {
        return Order.checkRating(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    reorderDataDetails({ commit }, data) {
        return Order.reorderDetails(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    viewTrackOrderDetail({ commit }, data) {
        return Order.trackOrderCustomer(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    postUploadOrderImages({ commit }, data) {
        return Order.uploadOrderImages(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    postremoveOrderImages({ commit }, data) {
        return Order.removeOrderImages(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    getOrderDistancekm({ commit }, data) {
        return Order.getOrderDistance(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    OrderPreBooking({ commit }, data) {
        return Order.postOrderPreBooking(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    OrderPreBookingList({ commit }, data) {
        return Order.getOrderPreBookingList(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    getOrderListWithBook({ commit }, data) {
        return Order.getOrderListWithBooking(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    newOrderListData({ commit }, data) {
        return Order.newOrderList(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },
    
    getChowmanPayHistoryData({ commit }, data) {
        return Order.getChowmanPayHistory(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    chowmanPaymentCreateData({ commit }, data) {
        return Order.chowmanPayCreate(data).then(response => {
            if (response.data.code == 200) {                
                return response.data;
            }
            return response.data;
        });
    }, 
       
    getchowmanPayOrderDetailsData({ commit }, data) {
        return Order.chowmanPayOrderDetails(data).then(response => {
            if (response.data.code == 200) {                
                return response.data;
            }
            return response.data;
        });
    }, 
    getInvouceData({ commit }, data) {
        return Order.getOrderInvoice(data).then(response => {
            if (response.data.code == 200) {                
                return response.data;
            }
            return response.data;
        });
    }, 
    downloadInvoicePDF({ commit }, data) {
        return Order.downloadOrderInvoicePDF(data).then(response => {
            return response;
        });
    }, 
};
const mutations = {
    getOnGoingOrder(state, onGoingOrders) {
        state.onGoingOrders = [...onGoingOrders]
    },
    getPastOrder(state, pastOrder) {
        state.pastOrder = [...pastOrder]
    },
    viewOrderDetail(state, orderDetail) {
        state.orderDetail = [...orderDetail]
    },
    placeOrderData(state, orderData) {
        state.place_order_data = {...orderData };
    },
    clearPlaceOrderData(state) {
        state.place_order_data = [];
    },
    pickupdelivery(state, is_delivery) {
        state.isPickupDelivery = is_delivery;
    },
    chowmanPayPlaceOrder(state,data){        
        state.chowmanPayOrderData = data;
    },
    chowmanPayGiftPlaceOrder(state,data){        
        state.chowmanPayGiftVoucher = data;
    }

};
const getters = {
    onGoingOrders: state => state.onGoingOrders,
    pastOrder: state => state.pastOrder,
    orderDetail: state => state.orderDetail,
    place_order_data: state => state.place_order_data,
    isPickupDelivery: state => state.isPickupDelivery,
    chowmanPayOrderData:state=>state.chowmanPayOrderData,
    chowmanPayGiftVoucher:state=>state.chowmanPayGiftVoucher,
}

export const order = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};